"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const toMarkdown = (element, _context) => {
    var _a;
    if (!((_a = element.value) === null || _a === void 0 ? void 0 : _a.items) || element.value.items.length === 0) {
        return '';
    }
    const { items, type, x, y } = element.value;
    const lines = [];
    lines.push(`**${type.charAt(0).toUpperCase() + type.slice(1)} Chart**`);
    lines.push('');
    if (x || y) {
        const xLabel = 'X';
        const yLabel = 'Value';
        lines.push(`${xLabel} / ${yLabel}`);
        lines.push('');
    }
    lines.push('| Label | Value |');
    lines.push('|-------|-------|');
    items.forEach((item) => {
        const label = item.label || item.value || '';
        const value = item.val !== undefined ? item.val.toString() : '';
        lines.push(`| ${label} | ${value} |`);
    });
    lines.push('');
    return lines.join('\n');
};
exports.toMarkdown = toMarkdown;
